import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
console.log(process.env.REACT_APP_API_URL);
export const applicationApi = createApi({
  tagTypes: ['EventList', 'EventDetail', 'Questionaire', 'QuestionaireResult', 'Statistic'],
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL, credentials: 'include' }),
  endpoints: () => ({}),
});
